import { toastMessage } from './toast';
import * as userAuthActions from '../Redux/Actions/user';

export const validationError = (error) => {
    let validationErrs = error.data.data?.validations;
    if(validationErrs){
        return validationErrs && validationErrs.map(validationErr => toastMessage('error', validationErr));
    }else{
        return  toastMessage('error', error.data.message);
    }
};

export const initiateLogOut = (userID, dispatch, history) => {
    userAuthActions.userLogout({Id: userID}).then(res => {
        if(res.status === 200){
            dispatch(userAuthActions.userAuthLogout());
            localStorage.removeItem('jwt');
            document.cookie = 'jwt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
            localStorage.removeItem('persist:root');
            history.push('/');
        }else{
            toastMessage('error', 'Logout Failed');
        }
    });
};

export  const clearSession = (dispatch, history) => {
    dispatch(userAuthActions.userAuthLogout());
    localStorage.removeItem('jwt');
    document.cookie = 'jwt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    localStorage.removeItem('persist:root');
    history.push('/');
};

export const errorHandler = (err) => {
    console.log('err 2', err, err.response.status, err.response.status)
};